

























import Vue from 'vue';

import List from '@/models/soukai/List';
import Task from '@/models/soukai/Task';
import Workspace from '@/models/soukai/Workspace';

import TaskForm from './TaskForm.vue';
import TasksList from './TasksList.vue';

interface Data {
    showCompleted: boolean;
}

export default Vue.extend({
    components: {
        TaskForm,
        TasksList,
    },
    data(): Data {
        return {
            showCompleted: false,
        };
    },
    computed: {
        tasks(): Task[] {
            return this.$workspaces.active!.activeList.tasks || [];
        },
        pendingTasks(): Task[] {
            return this.tasks.filter((task: Task) => !task.completed);
        },
        completedTasks(): Task[] {
            return this.tasks.filter((task: Task) => task.completed);
        },
    },
});
